export default __webpack_public_path__ + "static/media/sabonBold.fd301bd0.ttf";